module.exports = __webpack_public_path__ + "static/pixel-pond-logo-white-1269b23de8df6bbff4d935903c7a839b.png";